import { publicAssetsURL } from '#build/paths.mjs';export default publicAssetsURL("/songpreview.png")